import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store'
import { isCookieEnabled, getCookie } from 'tiny-cookie'

Vue.use(VueI18n)

const lang = () => loadLangSessionFromCookie()

const loadLangSessionFromCookie = () => {
  const lang = isCookieEnabled() ? getCookie('select_lang') : store.getters.GET_LANG
  if (lang) {
    return lang
  } else {
    return store.getters.GET_LANG
  }
}

const locale = lang()

const messages = {
  [locale]: require(`./${locale}.json`)
}

const i18n = new VueI18n({
  locale, // set locale
  messages,
  fallbackLocale: 'vi',
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js